export const CURRENCY_DELETE_RESET = 'CURRENCY_DELETE_RESET'
export const CURRENCY_DELETE_SET_ERROR = 'CURRENCY_DELETE_SET_ERROR'
export const CURRENCY_DELETE_SET_DELETED = 'CURRENCY_DELETE_SET_DELETED'
export const CURRENCY_DELETE_TOGGLE_LOADING = 'CURRENCY_DELETE_TOGGLE_LOADING'
